import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { MaterialModule } from 'src/app/shared/material.module';
import { ShareMenuComponent } from 'src/app/shared/services/share-menu/share-menu.component';
import { AppCalendarService } from 'src/app/views/event/app-calendar/app-calendar.service';
import { ToastService } from '../../../shared/services/toast/toast.service';

@Component({
  selector: 'app-create-event',
  templateUrl: './create-event.component.html',
  styleUrls: ['./create-event.component.scss'],
  standalone: true,
  imports: [MaterialModule, ReactiveFormsModule, TranslateModule, FormsModule, ShareMenuComponent],
})
export class CreateEventComponent implements OnInit {
  @Input() inputData;
  @Input() hideSaveButton;
  @Input() currentView;
  view = 'todoDetails';
  createForm;
  emptyEvent = {
    _id: undefined,
    start: undefined,
    end: undefined,
    name: undefined,
    type: undefined,
    color: {
      primary: undefined,
      secondary: undefined,
    },
    meta: {
      location: undefined,
      notes: undefined,
    },
  };
  event;
  dialogTitle;
  type = 'create';
  freq = [
    { name: 'Non répété', value: 'Unrepeated' },
    { name: 'Hebdomadaire', value: 'Weekly' },
    { name: 'Mensuel', value: 'Monthly' },
    { name: 'Annuel', value: 'Yearly' },
  ];
  selectedFreq = 'Unrepeated';
  shareMenuData = {
    isEvent: true,
    users: [],
  };
  userList: [];
  data;
  buttonLock = false;
  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) private dialogData,
    @Optional() @Inject(MAT_BOTTOM_SHEET_DATA) private bottomSheetData,
    @Optional() public dialogRef: MatDialogRef<CreateEventComponent>,
    @Optional() public bottomSheetRef: MatBottomSheetRef<CreateEventComponent>,
    private calendarService: AppCalendarService,
    private toast: ToastService,
    private translate: TranslateService
  ) {
    this.data = this.dialogData || this.bottomSheetData;
    const data = this.data;
    if (data.event) {
      this.type = 'edit';
      this.dialogTitle = 'Edit event';
      this.userList = data.event.users;
      this.shareMenuData.users = data.event.users;
    }
    this.event = data ? data.event || this.emptyEvent : this.inputData ? this.inputData.event || this.emptyEvent : this.emptyEvent;

    this.selectedFreq = this.event.frequency || this.event.selectedFreq || 'Unrepeated';

    this.translate.onLangChange.subscribe((res) => {
      this.translateOptions();
    });
  }

  ngOnInit() {
    this.translateOptions();
    // this.type = "create"
    if (this.type != 'edit') {
      this.dialogTitle = this.translate.instant('Global.CreateEvent');
    }

    this.createForm = new UntypedFormGroup({
      _id: new UntypedFormControl(this.event._id),
      name: new UntypedFormControl(
        {
          value: this.event.name || '',
          disabled: this.type == 'edit' && !this.event.isAdmin,
        },
        [Validators.required]
      ),
      start: new UntypedFormControl(
        {
          value: this.event.start || moment(),
          disabled: (this.type == 'edit' && !this.event.isAdmin) || (this.inputData && this.inputData.command == 'show-todo'),
        },
        [Validators.required]
      ),
      end: new UntypedFormControl({
        value: this.event.end || moment(),
        disabled: (this.type == 'edit' && !this.event.isAdmin) || (this.inputData && this.inputData.command == 'show-todo'),
      }),
      notes: new UntypedFormControl({
        value: this.event.notes,
        disabled: this.type == 'edit' && !this.event.isAdmin,
      }),
    });
  }

  translateOptions() {
    this.freq.map((e) => {
      e.name = this.translate.instant(`Calendar.${e.value}`);
    });
  }

  checkDateValidity(date) {
    return date && (date instanceof Date || moment.isMoment(date)) ? true : false;
  }

  formDatesAreValid() {
    if (!this.createForm) {
      return false;
    }
    const formValue = this.createForm.value;
    formValue.selectedFreq = this.selectedFreq;
    if (!formValue.name.trim().length) {
      return false;
    }
    if (formValue.selectedFreq != 'Unrepeated') {
      return this.checkDateValidity(formValue.start) && this.checkDateValidity(formValue.end) && moment(formValue.start).isBefore(moment(formValue.end));
    } else {
      return this.checkDateValidity(formValue.start);
    }
  }
  setUserList(event) {
    this.userList = event;
  }

  createEvent() {
    // this.buttonLock = true;
    if (!this.selectedFreq) {
      this.toast.snackbar.open(this.translate.instant('Snackbar.IncorrectFrequency'), 'Ok', { duration: 2000 });
      return;
    }
    const eventForm = this.createForm.value;
    eventForm.users = this.userList;
    eventForm.contentID = this.data.contentID;
    eventForm.selectedFreq = this.selectedFreq;
    eventForm.start = moment(eventForm.start).utc().format();
    if (eventForm.selectedFreq == 'Unrepeated') {
      eventForm.end = moment(eventForm.end).add(1, 'hour').utc().format();
    } else {
      eventForm.end = moment(eventForm.end).utc().format();
    }

    this.calendarService.addEvent(eventForm).subscribe(
      (res) => {
        //  this.socketService.emitEvent('todo-event',{info: 'new-todo'})
        this.toast.snackbar.open(this.translate.instant('Snackbar.EventCreatedSuccess'), 'Ok', { duration: 2000 });
        this.close();
      },
      (err) => {
        console.error(err);
        this.buttonLock = false;
        this.toast.snackbar.open(this.translate.instant('Snackbar.EventCreatedFail'), 'Ok', { duration: 2000 });
      }
    );
  }
  editEvent() {
    this.buttonLock = true;
    const eventForm = this.createForm.value;
    eventForm.contentID = this.data.contentID;
    eventForm.users = this.userList;
    eventForm.selectedFreq = this.selectedFreq;
    eventForm.frequency = this.selectedFreq;
    this.calendarService.updateEventNameAndDescription(eventForm).subscribe(
      (res) => {
        // this.socketService.emitEvent('todo-event',{info:'edited-todo'})
        this.toast.snackbar.open(this.translate.instant('Snackbar.EventEditedSuccess'), 'Ok', { duration: 2000 });
        this.close();
      },
      (err) => {
        this.buttonLock = false;
        console.error(err);
        this.toast.snackbar.open(this.translate.instant('Snackbar.EventEditedFail'), 'Ok', { duration: 2000 });
      }
    );
  }
  submit() {
    if (this.type == 'edit') {
      this.editEvent();
    } else {
      this.createEvent();
    }
  }

  close() {
    this.createForm.reset();
    if (this.dialogRef) {
      this.dialogRef.close();
    }
    if (this.bottomSheetRef) {
      this.bottomSheetRef.dismiss();
    }
  }
}
